import React from 'react';
import { l } from 'app/blocks/common/codes';
import { getQueryParamSafe } from 'app/blocks/common/utils';
import { authenticateASLogin } from 'app/blocks/middleware/authentication';

import 'app/styles/uitextloader.scss';

export function isFinalizeLoginPage() {
    const queryParams = getQueryParamSafe(window.location.href);
    return !!(queryParams?.code && queryParams?.id_token);
}

export default class FinalizeLoginPage extends React.Component {
    async componentDidMount() {
        const ranStr = localStorage.getItem('STATE_ID');
        const queryParams = getQueryParamSafe(window.location.href);
        if (queryParams?.code && queryParams?.id_token) {
            queryParams.idToken = queryParams.id_token;
            delete queryParams.id_token;

            if (true || ranStr === queryParams?.state) {
                this.authenticateUser(queryParams);
            } else {
                setTimeout(() => {
                    window.location.replace('/index.html#errorRedirectHome');
                }, 2000);
            }
        }
    }

    timeoutPromise = () =>
        new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('Timeout occurred'));
            }, parseInt(l(`BUTTONS.AUTH_TIMEOUT`), 10));
        });

    authenticateUser = async queryParams => {
        try {
            await Promise.race([authenticateASLogin(queryParams), this.timeoutPromise()]);
            setTimeout(() => {
                window.location.replace('/index.html#dashboard');
            }, 2000);
        } catch (err) {
            setTimeout(() => {
                window.location.replace('/index.html#errorRedirectHome');
            }, 2000);
        }
    };

    render() {
        return (
            <div className="Loading-screen">
                <div className="loader" />
                <div style={{ fontSize: '20px', lineHeight: '30px', padding: '20px', textAlign: 'center' }}>
                    Please wait while you are taken to the Wiley Author Services Dashboard.
                </div>
            </div>
        );
    }
}
